/* ============================================================
   THE FOLKS — motion layer
   1. Bean-scatter intro (home, first load)
   2. Page-transition curtain
   3. Pinned horizontal café rail
   4. Drifting bean field on dark blocks
   5. Scroll velocity variable + magnetic buttons
   Loads before site.js so it can defer the reveals until the
   intro curtain has lifted.
   ============================================================ */
(function () {
  'use strict';

  var html = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var INTRO = html.classList.contains('ldr-on') && !reduce;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var ROAST = ['#4a2a1d', '#6b3b26', '#824240', '#a2613f', '#c8856f'];

  /* ---------------------------------------------------------
     Shared: draw one coffee bean
     --------------------------------------------------------- */
  function bean(ctx, x, y, r, rot, fill, crease) {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(rot);
    ctx.fillStyle = fill;
    ctx.beginPath();
    ctx.ellipse(0, 0, r, r * 0.7, 0, 0, 6.2832);
    ctx.fill();
    ctx.strokeStyle = crease;
    ctx.lineWidth = Math.max(1, r * 0.16);
    ctx.lineCap = 'round';
    ctx.beginPath();
    ctx.moveTo(-r * 0.74, 0);
    ctx.bezierCurveTo(-r * 0.24, -r * 0.36, r * 0.24, r * 0.36, r * 0.74, 0);
    ctx.stroke();
    ctx.restore();
  }

  /* =========================================================
     1. INTRO — a roast, in miniature.

     Act I   green beans drop into the drum
     Act II  they darken along the roast curve while the
             temperature climbs and the drum sways
     Act III first crack — they snap, chaff flies
     Act IV  the beans pull together into the Folks mark,
             hold, then blow apart as the curtain lifts

     Returning visitors get the short cut (Act IV only).
     ========================================================= */
  var SEEN = 'folks.intro';
  function ckGet(k) {
    var m = document.cookie.match('(?:^|; )' + k.replace(/\./g, '\\.') + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function ckSet(k, v) {
    try { document.cookie = k + '=' + v + ';path=/;max-age=31536000;samesite=lax'; } catch (e) {}
  }

  /* Roast curve, in brand colours: raw green → drying → yellowing →
     Maillard → medium → dark. Sampled by progress 0..1. */
  var CURVE = [
    [124, 171, 131], /* green   */
    [131, 178, 137], /* green   */
    [179, 193, 132], /* drying  */
    [234, 225, 142], /* yellow  */
    [209, 154, 119], /* maillard*/
    [200, 133, 111], /* terra   */
    [130, 66, 64],   /* brick   */
    [74, 42, 29]     /* dark    */
  ];
  function roastColor(p) {
    p = clamp(p, 0, 1) * (CURVE.length - 1);
    var i = Math.min(CURVE.length - 2, p | 0), f = p - i;
    var a = CURVE[i], b = CURVE[i + 1];
    return 'rgb(' + ((a[0] + (b[0] - a[0]) * f) | 0) + ',' +
                    ((a[1] + (b[1] - a[1]) * f) | 0) + ',' +
                    ((a[2] + (b[2] - a[2]) * f) | 0) + ')';
  }

  var STAGES = [
    [0.00, 'Green', 'Verde'],
    [0.18, 'Drying', 'Secagem'],
    [0.40, 'Yellowing', 'Amarelecimento'],
    [0.62, 'Maillard', 'Maillard'],
    [0.86, 'First crack', 'Primeira quebra'],
    [1.00, 'Ready', 'Pronto']
  ];

  /* Read the Folks mark as a point cloud, so the beans can build it.
     Poisson-ish thinning keeps them from clumping. */
  function markPoints(n, cb) {
    var img = new Image();
    img.onload = function () {
      var H0 = 150, W0 = Math.max(1, Math.round(H0 * (img.width / img.height) || H0));
      var c = document.createElement('canvas');
      c.width = W0; c.height = H0;
      var cx = c.getContext('2d');
      cx.drawImage(img, 0, 0, W0, H0);
      var d;
      try { d = cx.getImageData(0, 0, W0, H0).data; } catch (e) { cb(null); return; }
      var all = [], x, y;
      for (y = 0; y < H0; y++) {
        for (x = 0; x < W0; x++) {
          if (d[(y * W0 + x) * 4 + 3] > 140) all.push([x / W0, y / H0]);
        }
      }
      if (all.length < n) { cb(null); return; }
      /* thin to n well-spread points */
      var min = Math.sqrt((all.length / (W0 * H0)) / n) * 0.78;
      var out = [], tries = 0, cap = n * 260;
      while (out.length < n && tries++ < cap) {
        var q = all[(Math.random() * all.length) | 0], ok = true;
        for (var i = 0; i < out.length; i++) {
          var dx = out[i][0] - q[0], dy = out[i][1] - q[1];
          if (dx * dx + dy * dy < min * min) { ok = false; break; }
        }
        if (ok) out.push(q);
      }
      while (out.length < n) out.push(all[(Math.random() * all.length) | 0]);
      cb(out, img.width / img.height);
    };
    img.onerror = function () { cb(null); };
    img.src = (window.FOLKS_ASSETS && window.FOLKS_ASSETS.mark) || '';
  }

  function intro() {
    var FULL = !ckGet(SEEN);
    ckSet(SEEN, '1');

    var el = document.createElement('div');
    el.className = 'ldr' + (FULL ? '' : ' ldr--quick');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-label', 'Loading The Folks');
    el.innerHTML =
      '<canvas class="ldr__c" aria-hidden="true"></canvas>' +
      '<div class="ldr__in">' +
      '<p class="ldr__claim" data-en="Slow moments in a fast city." data-pt="Momentos calmos numa cidade apressada.">Slow moments in a fast city.</p>' +
      '</div>' +
      (FULL ? '<div class="ldr__meta" aria-hidden="true">' +
        '<span class="ldr__stage">Green</span><span class="ldr__temp">20°</span></div>' : '') +
      '<div class="ldr__bar" aria-hidden="true"><i></i></div>';
    document.body.appendChild(el);
    html.classList.remove('ldr-cover');

    var cv = $('.ldr__c', el);
    var barFill = $('.ldr__bar i', el);
    var stageEl = $('.ldr__stage', el);
    var tempEl = $('.ldr__temp', el);
    var ctx = cv.getContext('2d');
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var W = 0, H = 0, small = false;
    var raf = 0, done = false, blown = false;

    /* --- timeline (ms) ---------------------------------------------------
       Beans drop in, each one straight to its own place in the mark.
       They arrive top-first, so the logo fills downward. No pile, no
       bounce, no coming back up.                                        */
    var SPAN = FULL ? 900 : 260;   /* spread of drop start times   */
    var FALL = FULL ? 760 : 520;   /* how long one bean is in flight */
    var HOLD = FULL ? 420 : 240;   /* the mark sits complete         */
    var LAND = SPAN + FALL;
    var T_END = LAND + HOLD;

    function size() {
      W = window.innerWidth; H = window.innerHeight;
      small = W < 700;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    size();

    var count = small ? 100 : 168;
    var mh = Math.min(H * 0.44, small ? 300 : 400);
    var br = clamp(mh / (small ? 24 : 34), 4.6, 9.6);
    var mar = 348 / 305, mw = mh * mar;
    var ox = (W - mw) / 2, oy = H * 0.44 - mh / 2;

    var beans = [], chaff = [], pts = null;
    var t0 = 0;   /* clock starts when the mark's points are ready */

    for (var i = 0; i < count; i++) {
      beans.push({
        r: br * (0.86 + Math.random() * 0.32),
        rot0: Math.random() * 6.28,
        spin: (Math.random() - 0.5) * 7,
        x0: 0, y0: 0, tx: 0, ty: 0, trot: 0,
        d: 0, land: false, crack: -1,
        sway: 0.5 + Math.random() * 1.6,
        phase: Math.random() * 6.28
      });
    }

    function place() {
      /* top rows of the mark get the earliest beans */
      var order = pts.slice(0, count).sort(function (a, b) { return a[1] - b[1]; });
      for (var k = 0; k < beans.length; k++) {
        var b = beans[k], t = order[k % order.length];
        b.tx = ox + t[0] * mw;
        b.ty = oy + t[1] * mh;
        b.trot = Math.round(Math.random() * 4) * 1.5708;
        b.x0 = b.tx + (Math.random() - 0.5) * (small ? 90 : 150);
        b.y0 = -30 - Math.random() * H * 0.35;
        b.d = (k / beans.length) * SPAN * (0.82 + Math.random() * 0.36);
      }
    }

    function layout() {
      size();
      mh = Math.min(H * 0.44, small ? 300 : 400);
      mw = mh * mar;
      ox = (W - mw) / 2; oy = H * 0.44 - mh / 2;
      if (pts && !blown) place();
    }
    window.addEventListener('resize', layout);

    markPoints(count, function (p, ar) {
      if (!p) { finish(); return; }
      pts = p; mar = ar || mar; mw = mh * mar; ox = (W - mw) / 2;
      place();
      t0 = performance.now();
      raf = requestAnimationFrame(step);
      setTimeout(tick, 60);
    });

    function step() {
      var e = performance.now() - t0;
      ctx.clearRect(0, 0, W, H);

      /* faint point-cloud of the mark, so the target is always readable */
      if (!blown) {
        ctx.fillStyle = 'rgba(1,1,1,0.055)';
        for (var g = 0; g < pts.length; g++) {
          ctx.beginPath();
          ctx.arc(ox + pts[g][0] * mw, oy + pts[g][1] * mh, 1.7, 0, 6.2832);
          ctx.fill();
        }
      }

      /* warm glow rising under the mark as the roast develops */
      var gp = clamp(e / LAND, 0, 1);
      if (FULL) {
        var gg = ctx.createRadialGradient(W / 2, H * 0.44, 0, W / 2, H * 0.44, mw * 1.15);
        gg.addColorStop(0, 'rgba(200,133,111,' + (0.035 + gp * 0.11).toFixed(3) + ')');
        gg.addColorStop(1, 'rgba(200,133,111,0)');
        ctx.fillStyle = gg;
        ctx.fillRect(0, 0, W, H);
      }

      for (var i = 0; i < beans.length; i++) {
        var b = beans[i];
        var f = clamp((e - b.d) / FALL, 0, 1);          /* flight 0..1 */
        if (f <= 0 && !blown) continue;

        /* easeOutCubic — quick drop, soft settle, never overshoots up */
        var k = 1 - Math.pow(1 - f, 3);
        var x, y, rot;

        if (blown) {
          b.fy = (b.fy || 0) + 0.55;
          b.by = (b.by || 0) + b.fy;
          b.bx = (b.bx || 0) + (b.bvx || 0);
          x = b.tx + b.bx; y = b.ty + b.by; rot = b.trot + b.by * 0.006;
        } else {
          x = b.x0 + (b.tx - b.x0) * k;
          y = b.y0 + (b.ty - b.y0) * k;
          rot = b.rot0 + (b.trot + b.spin - b.rot0) * k;
          /* a breath of drift while airborne, gone by the time it lands */
          if (f < 1) x += Math.sin(e / 210 + b.phase) * b.sway * (1 - k) * 6;
          if (f >= 1 && !b.land) {
            b.land = true;
            b.crack = 0;
            if (FULL && Math.random() < 0.6) {
              chaff.push({
                x: x, y: y,
                vx: (Math.random() - 0.5) * 1.6,
                vy: 0.2 + Math.random() * 0.9,
                r: 1.3 + Math.random() * 2.3,
                rot: Math.random() * 6.28,
                vr: (Math.random() - 0.5) * 0.34,
                a: 1
              });
            }
          }
        }

        /* raw and green on the way in, roasted by the time it lands */
        var col = FULL ? roastColor(Math.pow(f, 0.85)) : roastColor(1);
        bean(ctx, x, y, b.r, rot, col, 'rgba(247,244,238,0.30)');

      }

      for (i = chaff.length - 1; i >= 0; i--) {
        var c = chaff[i];
        c.vy += 0.02; c.vx *= 0.995;
        c.x += c.vx; c.y += c.vy; c.rot += c.vr; c.a -= 0.012;
        if (c.a <= 0) { chaff.splice(i, 1); continue; }
        ctx.save();
        ctx.globalAlpha = Math.max(0, c.a) * 0.75;
        ctx.translate(c.x, c.y); ctx.rotate(c.rot);
        ctx.fillStyle = '#cbbfa4';
        ctx.fillRect(-c.r, -c.r * 0.34, c.r * 2, c.r * 0.68);
        ctx.restore();
      }

      if (e >= LAND && !el.classList.contains('is-mark')) el.classList.add('is-mark');

      raf = requestAnimationFrame(step);
    }

    var loaded = document.readyState === 'complete';
    window.addEventListener('load', function () { loaded = true; });
    var lastStage = -1;

    function tick() {
      var e = performance.now() - t0;
      var p = clamp(e / T_END, 0, 1);
      if (!loaded) p = Math.min(p, 0.92);
      barFill.style.width = (p * 100).toFixed(1) + '%';

      if (FULL && stageEl) {
        var rp = clamp(e / LAND, 0, 1);
        var si = 0;
        for (var k = 0; k < STAGES.length; k++) if (rp >= STAGES[k][0]) si = k;
        if (si !== lastStage) {
          lastStage = si;
          stageEl.setAttribute('data-en', STAGES[si][1]);
          stageEl.setAttribute('data-pt', STAGES[si][2]);
          stageEl.textContent = STAGES[si][lang2() === 'pt' ? 2 : 1];
          stageEl.classList.remove('is-new');
          void stageEl.offsetWidth;
          stageEl.classList.add('is-new');
        }
        tempEl.textContent = Math.round(20 + rp * 185) + '°';
      }

      if ((loaded && e >= T_END) || e > 4600) { finish(); return; }
      setTimeout(tick, 80);
    }
    setTimeout(finish, 5400);

    function lang2() {
      return (document.documentElement.lang || 'en').toLowerCase().indexOf('pt') === 0 ? 'pt' : 'en';
    }

    function finish() {
      if (done) return;
      done = true;
      barFill.style.width = '100%';
      /* the mark lets go downward — nothing travels back up */
      for (var i = 0; i < beans.length; i++) {
        var b = beans[i];
        b.fy = 0.4 + Math.random() * 1.4;
        b.by = 0; b.bx = 0;
        b.bvx = (b.tx - W / 2) * 0.006;
      }
      blown = true;
      setTimeout(function () {
        el.classList.add('is-out');
        html.classList.remove('ldr-on');
        if (window.folksInitReveals) window.folksInitReveals();
        document.dispatchEvent(new CustomEvent('folksintro'));
        setTimeout(function () {
          cancelAnimationFrame(raf);
          el.remove();
        }, 1100);
      }, 220);
    }
  }

  /* =========================================================
     2. PAGE CURTAIN — internal navigation wipe
     ========================================================= */
  function curtain() {
    if (reduce) return;
    var c = document.createElement('div');
    c.className = 'curtain';
    c.setAttribute('aria-hidden', 'true');
    c.innerHTML = '<i class="curtain__crema"></i><span><img src="' + ((window.FOLKS_ASSETS && window.FOLKS_ASSETS.mark) || '') + '" alt="" width="54" height="47"></span>';
    document.body.appendChild(c);

    document.addEventListener('click', function (ev) {
      if (ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
      var a = ev.target.closest ? ev.target.closest('a') : null;
      if (!a || !a.href || a.target === '_blank' || a.hasAttribute('download')) return;
      var u;
      try { u = new URL(a.href); } catch (e) { return; }
      if (u.origin !== location.origin) return;
      if (/^\/(checkout|cart\/|account|apps|tools|services)/.test(u.pathname)) return;
      if (a.hasAttribute('data-no-curtain') || a.closest('[data-no-curtain]')) return;
      if (u.pathname === location.pathname && u.search === location.search && u.hash) return;
      if (/^(mailto|tel):/.test(a.getAttribute('href') || '')) return;
      ev.preventDefault();
      c.classList.add('is-in');
      setTimeout(function () { location.href = a.href; }, 430);
    });

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) c.classList.remove('is-in');
    });
  }

  /* =========================================================
     3. PINNED CAFÉ RAIL
     ========================================================= */
  var rail = null;
  function buildRail() {
    var host = $('#cafeRail');
    if (!host) return;
    var track = $('.rail__track', host);
    var locs = window.FOLKS_LOCATIONS || [];
    var esc = window.folksEsc || function (s) { return s; };
    track.innerHTML = locs.map(function (l, i) {
      var on = window.folksOpenNow ? window.folksOpenNow(l) : null;
      var S = window.FOLKS_STR || {};
      var live = on
        ? '<span class="rail__live' + (on.open ? '' : ' is-shut') + '"><b></b>' +
          '<span>' + esc(on.open ? (S.open_now || 'Open now') : (S.closed || 'Closed')) + '</span></span> · <span>' + esc(on.range) + '</span>'
        : '';
      return '<a class="rail__card" href="' + esc(l.url) + '">' +
        '<img src="' + esc(l.image) + '" alt="The Folks ' + esc(l.name) + '" loading="lazy" width="1250" height="1350">' +
        '<span class="rail__cap">' +
        '<span class="rail__n">0' + (i + 1) + ' · ' + esc(l.area) + '</span>' +
        '<span class="rail__t">' + esc(l.name) + '</span>' +
        '<span class="rail__m">' + live + '</span>' +
        '<span class="rail__m">★ ' + esc(String(l.rating)) + ' · ' + esc(String(l.reviews)) + ' ' + ((window.FOLKS_STR && window.FOLKS_STR.reviews) || 'reviews') + '</span>' +
        '</span></a>';
    }).join('');

    rail = { host: host, track: track, win: $('.rail__win', host), prog: $('.rail__prog i', host), dist: 0 };
    layoutRail();
    window.addEventListener('resize', layoutRail);
  }

  function layoutRail() {
    if (!rail) return;
    if (window.innerWidth <= 1000 || reduce) {
      rail.host.style.height = '';
      rail.track.style.transform = '';
      rail.dist = 0;
      return;
    }
    var pad = parseFloat(getComputedStyle(rail.win).paddingLeft) || 0;
    rail.dist = Math.max(0, rail.track.scrollWidth - (rail.win.clientWidth - pad * 2));
    rail.host.style.height = (window.innerHeight + rail.dist * 1.15) + 'px';
  }

  function frameRail() {
    if (!rail || !rail.dist) return;
    var r = rail.host.getBoundingClientRect();
    var total = rail.host.offsetHeight - window.innerHeight;
    if (total <= 0) return;
    var p = clamp(-r.top / total, 0, 1);
    rail.track.style.transform = 'translate3d(' + (-p * rail.dist).toFixed(1) + 'px,0,0)';
    if (rail.prog) rail.prog.style.transform = 'scaleX(' + p.toFixed(3) + ')';
  }

  /* =========================================================
     4. BEAN FIELD — slow drift on dark blocks
     ========================================================= */
  var fields = [];
  function buildFields() {
    if (reduce) return;
    $$('[data-beans]').forEach(function (host) {
      if (host.dataset.beansDone) return;
      host.dataset.beansDone = '1';
      var cv = document.createElement('canvas');
      cv.className = 'beanfield';
      cv.setAttribute('aria-hidden', 'true');
      /* inline so the canvas can never fall back into flow and inflate the block */
      cv.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;' +
                         'z-index:0;pointer-events:none';
      host.insertBefore(cv, host.firstChild);
      var f = { host: host, cv: cv, ctx: cv.getContext('2d'), beans: [], w: 0, h: 0, vis: false };
      fields.push(f);
      sizeField(f);
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { f.vis = e.isIntersecting; if (e.isIntersecting) cv.classList.add('in'); });
      }, { rootMargin: '15% 0px' });
      io.observe(host);
    });
    window.addEventListener('resize', function () { fields.forEach(sizeField); });
  }

  function sizeField(f) {
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    f.w = f.host.clientWidth;
    f.h = f.host.clientHeight;
    f.cv.width = Math.round(f.w * dpr);
    f.cv.height = Math.round(f.h * dpr);
    f.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var n = Math.max(10, Math.min(26, Math.round(f.w * f.h / 62000)));
    if (f.beans.length !== n) {
      f.beans = [];
      for (var i = 0; i < n; i++) {
        f.beans.push({
          x: Math.random() * f.w,
          y: Math.random() * f.h,
          r: 8 + Math.random() * 16,
          rot: Math.random() * 6.28,
          vr: (Math.random() - 0.5) * 0.006,
          vx: (Math.random() - 0.5) * 0.12,
          vy: -0.06 - Math.random() * 0.1,
          d: 0.4 + Math.random() * 0.9
        });
      }
    }
  }

  function frameFields(scrollY) {
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (!f.vis || !f.w) continue;
      var c = f.ctx;
      c.clearRect(0, 0, f.w, f.h);
      for (var j = 0; j < f.beans.length; j++) {
        var b = f.beans[j];
        b.x += b.vx;
        b.y += b.vy;
        b.rot += b.vr;
        if (b.y < -40) b.y = f.h + 40;
        if (b.x < -40) b.x = f.w + 40;
        if (b.x > f.w + 40) b.x = -40;
        var oy = (scrollY * 0.045 * b.d) % (f.h + 80);
        bean(c, b.x, (b.y + oy) % (f.h + 80) - 40, b.r, b.rot, 'rgba(231,224,209,0.075)', 'rgba(231,224,209,0.05)');
      }
    }
  }

  /* =========================================================
     5. SCROLL VELOCITY + MAGNETIC BUTTONS
     ========================================================= */
  var lastY = window.scrollY, vel = 0;
  function frameVel(y) {
    var d = y - lastY;
    lastY = y;
    vel += (d - vel) * 0.18;
    var v = clamp(vel, -40, 40);
    if (Math.abs(v) > 0.2 || Math.abs(vel) < 0.4) html.style.setProperty('--vel', v.toFixed(2));
  }

  function magnetic() {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    $$('.btn--lg').forEach(function (b) {
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / r.width;
        var dy = (e.clientY - (r.top + r.height / 2)) / r.height;
        b.style.transform = 'translate3d(' + (dx * 7).toFixed(1) + 'px,' + (dy * 5).toFixed(1) + 'px,0)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }


  /* =========================================================
     7. POINTER DEPTH — tilt, sheen, spotlight, hero drift
     ========================================================= */
  var TILT = '.pcard, .rvw, .rail__card, .cafenav__i, .tiltwrap';
  var LAMP_ON = '.bg-ink, .bg-indigo, .bg-brick, .bg-teal, .bg-terra';

  function tilt() {
    if (reduce || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;

    document.addEventListener('pointermove', function (e) {
      var el = e.target.closest ? e.target.closest(TILT) : null;
      if (!el) return;
      var r = el.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      var max = el.classList.contains('rail__card') ? 5 : 7;
      el.style.setProperty('--ty', ((px - 0.5) * 2 * max).toFixed(2) + 'deg');
      el.style.setProperty('--tx', ((0.5 - py) * 2 * max).toFixed(2) + 'deg');
      el.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
      el.style.setProperty('--my', (py * 100).toFixed(1) + '%');
      if (!el.classList.contains('is-tilting')) el.classList.add('is-tilting');
    }, { passive: true });

    document.addEventListener('pointerout', function (e) {
      var el = e.target.closest ? e.target.closest(TILT) : null;
      if (!el || (e.relatedTarget && el.contains(e.relatedTarget))) return;
      el.classList.remove('is-tilting');
      el.style.removeProperty('--tx');
      el.style.removeProperty('--ty');
    }, { passive: true });
  }

  function lamps() {
    if (reduce) return;
    $$(LAMP_ON).forEach(function (el) {
      el.classList.add('lamp');
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', (((e.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
        el.style.setProperty('--my', (((e.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
        el.style.setProperty('--lamp', '1');
      }, { passive: true });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--lamp', '0');
      }, { passive: true });
    });
  }

  function heroDrift() {
    if (reduce || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    var figs = $$('.hero__strip .media');
    if (!figs.length) return;
    window.addEventListener('pointermove', function (e) {
      var cx = (e.clientX / window.innerWidth - 0.5);
      var cy = (e.clientY / window.innerHeight - 0.5);
      figs.forEach(function (f, i) {
        var d = (i % 2 ? 1 : -1) * (7 + i * 3);
        f.style.setProperty('--px', (cx * d).toFixed(1) + 'px');
        f.style.setProperty('--py', (cy * d * 0.6).toFixed(1) + 'px');
      });
    }, { passive: true });
  }

  /* =========================================================
     8. BEAN BURST — a small shower of beans on add-to-cart
     ========================================================= */
  function burstAt(x, y, n) {
    if (reduce) return;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < n; i++) {
      var b = document.createElement('i');
      b.className = 'burst';
      var ang = (-Math.PI / 2) + (Math.random() - 0.5) * 2.1;
      var dist = 70 + Math.random() * 130;
      b.style.left = x + 'px';
      b.style.top = y + 'px';
      b.style.background = ROAST[(Math.random() * ROAST.length) | 0];
      b.style.setProperty('--dx', (Math.cos(ang) * dist).toFixed(0) + 'px');
      b.style.setProperty('--dy', (Math.sin(ang) * dist * 0.7 + 150).toFixed(0) + 'px');
      b.style.setProperty('--dr', ((Math.random() * 720 - 360) | 0) + 'deg');
      b.style.setProperty('--dur', (760 + Math.random() * 460 | 0) + 'ms');
      b.addEventListener('animationend', function () { this.remove(); });
      frag.appendChild(b);
    }
    document.body.appendChild(frag);
  }

  function beanButtons() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-add], .js-add, [data-burst]') : null;
      if (!b) return;
      var r = b.getBoundingClientRect();
      burstAt(r.left + r.width / 2, r.top + r.height / 2, 14);
    }, { passive: true });
    window.folksBurst = burstAt;
  }

  /* =========================================================
     LOOP + BOOT
     ========================================================= */
  function loop() {
    var y = window.scrollY;
    frameVel(y);
    frameRail();
    frameFields(y);
    requestAnimationFrame(loop);
  }

  function boot() {
    buildRail();
    buildFields();
    magnetic();
    curtain();
    tilt();
    lamps();
    heroDrift();
    beanButtons();
    document.addEventListener('langchange', function () {
      if (rail) {
        var p = rail.track.style.transform;
        buildRail();
        rail.track.style.transform = p;
      }
    });
    requestAnimationFrame(loop);
  }

  if (INTRO) intro();
  else html.classList.remove('ldr-cover', 'ldr-on');

  /* run after site.js has booted (it registers its listener first) */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { requestAnimationFrame(boot); });
  } else {
    requestAnimationFrame(boot);
  }
})();
